import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { debounceTime, finalize, switchMap } from 'rxjs/operators';
import { AccountSubGroupsServiceProxy, CreateOrEditAccountSubGroupDto } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

@Component({
    selector: 'createOrEditAccountSubGroupModal',
    templateUrl: './create-or-edit-accountSubGroup-modal.component.html',
    standalone: false,
})
export class CreateOrEditAccountSubGroupModalComponent extends AppComponentBase implements OnInit {
    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;

    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    accountSubGroup: CreateOrEditAccountSubGroupDto = new CreateOrEditAccountSubGroupDto();

    constructor(
        injector: Injector,
        private _accountSubGroupsServiceProxy: AccountSubGroupsServiceProxy,
        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    ngOnInit(): void {}

    show(accountSubGroupId?: number): void {
        if (!accountSubGroupId) {
            this.accountSubGroup = new CreateOrEditAccountSubGroupDto();
            this.accountSubGroup.id = accountSubGroupId;

            this.active = true;
            this.modal.show();
        } else {
            this._accountSubGroupsServiceProxy.getAccountSubGroupForEdit(accountSubGroupId).subscribe((result) => {
                this.accountSubGroup = result.accountSubGroup;

                this.active = true;
                this.modal.show();
            });
        }
    }

    save(): void {
        this.saving = true;

        this._accountSubGroupsServiceProxy
            .createOrEdit(this.accountSubGroup)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.close();
                this.modalSave.emit(null);
            });
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }
}
